<template>
  <div class="playback-insight-item-container">
    <div class="playback-insight-item row">
      <div class="col-md-6">
        <div class="playback-insight-item-title small mb-2">PLAYBACK ID</div>
        <h5 class="text-secondary">{{ playback.playbackId }}</h5>
        <div class="mb-2">
          <span class="playback-insight-item-user-id" v-if="userId">
            <i class="icon-color fa fa-user pr-1" />User ID: {{ userId }}
          </span>
        </div>
        <div>
          <span class="playback-insight-item-datetime">
            <i class="icon-color fa fa-calendar pr-1" />{{ playbackDate }}
          </span>
          <span class="playback-insight-item-datetime">
            <i class="icon-color fa fa-clock pl-2 pr-1" />{{ playbackTime }}
          </span>
          <span class="playback-insight-item-os">
            <i class="fa fa-windows pl-2 pr-1" v-if="osFamily === 'Windows'" />
            <i class="fa fa-apple pl-2 pr-1" v-else-if="osFamily === 'Mac OS X' || osFamily === 'iOS'" />
            <i class="fa fa-android pl-2 pr-1" v-else-if="osFamily === 'Android'" />
          </span>
        </div>
      </div>
      <div class="col-md-3 hidden-mobile">
        <div class="playback-insight-item-title small">
          BUFFERING FOUND
        </div>
        <h1
          class="buffer-value mt-2"
          :class="{
            'zero-value': bufferZero
          }" >
          {{ playback.bufferCount }}
        </h1>
      </div>
      <div class="col-md-3 hidden-mobile">
        <div class="playback-insight-item-title small">
          ERROR FOUND
        </div>
        <h1
          class="error-value mt-2"
          :class="{
            'zero-value': errorZero
          }" >
          {{ playback.errorCount }}
        </h1>
      </div>
      <div class="playback-insight-item-mobile mt-2">
        <div class="mobile-flex-item">
          <div class="playback-insight-item-title small">
            BUFFERING
          </div>
          <h5
            class="buffer-value mt-2"
            :class="{
              'zero-value': bufferZero
            }" >
            {{ playback.bufferCount }}
          </h5>
        </div>
        <div class="mobile-flex-item">
          <div class="playback-insight-item-title small">
            ERROR
          </div>
          <h5
            class="error-value mt-2"
            :class="{
              'zero-value': errorZero
            }" >
            {{ playback.errorCount }}
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: ['playback'],
  computed: {
    userId() {
      return this.playback.userId;
    },
    playbackDate() {
      return moment(this.playback.clientTimestamp).format('DD/MM/YYYY');
    },
    playbackTime() {
      return moment(this.playback.clientTimestamp).format('HH:mm');
    },
    osFamily() {
      return this.playback.osFamily;
    },
    browser() {
      return this.playback.uaFamily;
    },
    bufferZero() {
      return this.playback.bufferCount === 0;
    },
    errorZero() {
      return this.playback.errorCount === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.buffer-value {
  color: $warning;
}
.error-value {
  color: $danger;
}
.zero-value {
  color: $gray-300;
}

h5, h1 {
  font-weight: normal;
}

.playback-insight-item-container {
  margin: ($spacer * .5) 0;
  padding: $spacer;
  border: 1px solid $gray-200;
  box-shadow: 2.5px 2.5px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  align-items: center;
  transition: all .3s ease-out;
}

.playback-insight-item-container:hover {
  cursor: pointer;
  box-shadow: 2.5px 2.5px 5px rgba(0, 0, 0, 0.5);
  border: 1px solid $gray-400;
}

.playback-insight-item-title {
  color: $gray-500;
}

.playback-insight-item-mobile {
  display: none;
}

@media (max-width: 575.98px) {
  .hidden-mobile {
    display: none;
  }

  .playback-insight-item-mobile {
    display: flex;
    width: 100%;
    padding: 0 15px;

    .mobile-flex-item {
      flex: 0 0 50%;
    }
  }
}
</style>
